import {
  IconKey,
  IconCircleCheck,
  IconX,
  IconInfoCircle,
} from "@tabler/icons-react";
import { PERMISSIONS } from "./data";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function PermissionsCard() {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconKey size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Permissions</div>
            <div className={styles.cardSubtitle}>
              What you can do on this platform
            </div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.permGrid}>
          {PERMISSIONS.map((p) => (
            <div
              key={p.label}
              className={`${styles.permChip} ${p.granted ? styles.permGranted : styles.permDenied}`}
            >
              {p.granted ? (
                <IconCircleCheck
                  size={17}
                  style={{ color: "#10b981", flexShrink: 0 }}
                />
              ) : (
                <IconX size={17} style={{ color: "#dc2626", flexShrink: 0 }} />
              )}
              <span
                className={
                  p.granted ? styles.permLabelGranted : styles.permLabelDenied
                }
              >
                {p.label}
              </span>
            </div>
          ))}
        </div>
        <p className={styles.permFootnote}>
          <IconInfoCircle size={14} />
          Contact your organisation administrator to adjust role permissions.
        </p>
      </div>
    </div>
  );
}
